import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { MenuTwoTone } from 'common/icons';
import { Routes } from 'common/enums';
import { appContext } from 'common/contexts';
import styles from './menu.module.css';
import Notifications from '../notifications/notifications';

type MenuProps = {
  onOpenDrawer?: () => void;
  onOpenReport?: () => void;
};

const Menu: React.FC<MenuProps> = ({
  onOpenDrawer = () => null,
  onOpenReport = () => null,
}) => {
  const [t] = useTranslation();
  const history = useHistory();
  const [state, actions] = useContext(appContext);
  const { name } = state;

  const handleExternalOrdersClick = () => {
    history.push(Routes.ExternalOrders);
  };

  const handlePosTerminalClick = () => {
    history.push(Routes.Terminal);
  };

  const handleOrderViewed = (orderId: string) => {
    // Find the order and update its isView property
    const order = state.orders.find(order => order.id === orderId);
    
    if (order) {
      const updatedOrder = { ...order, isView: true };
      actions.orders.updateSelected(updatedOrder);
    }
  };
  
  const handleSelectOrder = (orderId: string) => {
    // Seleccionar la orden para mostrarla en la terminal
    actions.orders.select(orderId);
  };

  return (
    <div className={styles.root}>
      <div className={styles.left} />
      <div className={styles.right}>
        {name && <div className={styles.userName}>{name}</div>}
        <Notifications 
          onOrderViewed={handleOrderViewed}
          onSelectOrder={handleSelectOrder}
        />
        <button className={styles.menuBtn} onClick={() => onOpenReport()} style={{ display: 'none' }}>
          {t('terminal.dailyReport.menuLabel')}
        </button>
        <button className={styles.menuBtn} onClick={() => onOpenDrawer()}>
          <MenuTwoTone />
        </button>
      </div>
    </div>
  );
};

export default Menu;
